import {
    CLIENT_DETAILS_SUCCESS,
    CLIENT_DETAILS_FAILURE,
    CLIENT_DETAILS_RESET,
    CLIENT_SET_LOADING,
    CLIENT_SET_ERROR,
    CLIENT_CLEAR_ERROR,
    CLIENT_CREATE_REQUEST,
    CLIENT_CREATE_SUCCESS,
    CLIENT_CREATE_FAILURE,
    CLIENT_CREATE_RESET,
    CLIENT_SET_FILTERS,
    CLIENT_CLEAR_FILTERS,
    CLIENT_SET_SELECTED
} from "./ServiceActionType";

interface ClientState {
    clients: any[];
    emplopyelist: any[];
    loading: boolean;
    error: any | null;
    selectedClient: any | null;
    filters: any;
    message: string;
    operationStatus: {
        loading: boolean;
        success: boolean;
        error: any | null;
        message: string | null;
        response: any | null;
        action: string | null;
    };
}

const initialState: ClientState = {
    clients: [],
    emplopyelist: [],
    loading: false,
    error: null,
    selectedClient: null,
    filters: {},
    message: '',
    operationStatus: {
        loading: false,
        success: false,
        error: null,
        message: null,
        response: null,
        action: null
    }
};

const ClientReducer = (state = initialState, action: any): ClientState => {
    switch (action.type) {
        case CLIENT_SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case CLIENT_DETAILS_SUCCESS:
            console.log("CLIENT_DETAILS_SUCCESS - Payload:", action.payload);
            console.log("Employee List in Reducer:", action.payload.emplopyelist);
            
            return {
                ...state,
                clients: action.payload.records || [],
                emplopyelist: action.payload.emplopyelist || [],
                message: action.payload.message,
                error: null,
                loading: false
            };

        case CLIENT_DETAILS_FAILURE:
            // IMPORTANT: Check if the action contains employee list and preserve it
            const failureEmployeeList = action.emplopyelist || 
                                       action.payload?.emplopyelist || 
                                       state.emplopyelist || 
                                       [];
            
            console.log("CLIENT_DETAILS_FAILURE - Keeping employee list:", failureEmployeeList);
            console.log("Error message:", action.payload);
            
            return {
                ...state,
                clients: [],  // Clear clients on error
                // PRESERVE employee list if available in the action or keep existing
                emplopyelist: failureEmployeeList,
                error: action.payload,
                message: typeof action.payload === 'string' ? action.payload : action.payload?.message || 'Failed to fetch clients',
                loading: false
            };

        case CLIENT_DETAILS_RESET:
            return {
                ...initialState
            };

        case CLIENT_SET_ERROR:
            // Check if error payload contains employee list
            const errorEmployeeList = action.payload?.emplopyelist || 
                                     state.emplopyelist || 
                                     [];
            
            return {
                ...state,
                error: action.payload,
                loading: false,
                message: typeof action.payload === 'string' ? action.payload : action.payload?.message || 'An error occurred',
                // Preserve employee list if available
                emplopyelist: errorEmployeeList
            };

        case CLIENT_CLEAR_ERROR:
            return {
                ...state,
                error: null,
                message: ''
            };

        case CLIENT_SET_SELECTED:
            return {
                ...state,
                selectedClient: action.payload
            };

        case CLIENT_SET_FILTERS:
            return {
                ...state,
                filters: { ...state.filters, ...action.payload }
            };

        case CLIENT_CLEAR_FILTERS:
            return {
                ...state,
                filters: {}
            };

        case CLIENT_CREATE_REQUEST:
            return {
                ...state,
                operationStatus: {
                    loading: true,
                    success: false,
                    error: null,
                    message: null,
                    response: null,
                    action: null
                }
            };

        case CLIENT_CREATE_SUCCESS:
            console.log("CLIENT_CREATE_SUCCESS reducer action:", action);
            return {
                ...state,
                operationStatus: {
                    loading: false,
                    success: true,
                    error: null,
                    message: action.payload?.message || 'Operation completed successfully',
                    response: action.payload,
                    action: action.payload?.action || null
                },
                error: null,
                message: action.payload?.message || 'Operation completed successfully'
            };

        case CLIENT_CREATE_FAILURE:
            console.log("CLIENT_CREATE_FAILURE reducer action:", action);
            const errorMessage = typeof action.payload === 'string' ? action.payload : 'Operation failed';
            return {
                ...state,
                operationStatus: {
                    loading: false,
                    success: false,
                    error: action.payload,
                    message: errorMessage,
                    response: null,
                    action: null
                },
                error: action.payload,
                message: errorMessage
            };

        case CLIENT_CREATE_RESET:
            return {
                ...state,
                operationStatus: {
                    loading: false,
                    success: false,
                    error: null,
                    message: null,
                    response: null,
                    action: null
                }
            };

        default:
            return state;
    }
};

export default ClientReducer;